import React, { useEffect, useContext, useState, useRef } from 'react';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import MuiAlert from '@material-ui/lab/Alert';
import {
  Box,
  Button,
	Checkbox,
	Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  LinearProgress,
	MenuItem,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import { CSVLink } from 'react-csv';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import InsertInvitationRoundedIcon from '@material-ui/icons/InsertInvitationRounded';
import SortIcon from '@material-ui/icons/Sort';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import confetti from 'canvas-confetti';
import {
  StyledTableHeadCell,
  StyledTableHeadCell1,
  StyledTableHeadCell2,
  StyledTablePagination,
} from '../../customUI/table/TableStyles';
import GreenButton from '../../customUI/GreenButton';
import DefaultInput from '../../customUI/DefaultInput';
import StyledActiveChip from '../../customUI/ActiveChip';
import MobileTitle from '../../customUI/MobileTitle';
import MobileCallsCard from '../leads/MobileCallsCard';
import { leadsActions } from '../../store/leads-reducer';
import useStyles from '../leads/LeadsFullView.style';
import { storeContext } from '../provider/Provider';
import CallsTableRow from './CallOpportunitesRow';
import SubmitButton from '../../customUI/SubmitButton';
import RedButton from '../../customUI/RedButton';
import CheckIcon from '../../images/icon-proceed.svg';
import WarningIcon from '../../images/icon-warning.svg';



const { REACT_APP_FLASK_API_URL } = process.env;
const { REACT_APP_HIDE_SPAM } = process.env;

function Alert(props) {
  // eslint-disable-next-line
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CallsOpportunitiesTable = ({ handleSourceChange }) => {
  let isPhone = false;
  const { state, dispatch } = useContext(storeContext);
  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }
  const classes = useStyles();
  const [tableBodyHeight, setTableBodyHeight] = useState(300);
  const [isInternalFetching, setIsInternalFetching] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openSpamDialog, setOpenSpamDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openCallDialog, setOpenCallDialog] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [currDuration, setCurrDuration] = useState(null);
  const [sources, setSources] = useState(null);
  const [currSource, setCurrSource] = useState([]);
  const [orderBy, setOrderBy] = useState('-called_at_new');
  const [fullName, setFullName] = useState('');
  const [message, setMessage] = useState('');
  const [confirmationStep, setConfirmationStep] = useState(false);
  const [email, setEmail] = useState('');
  const [currentCall, setCurrentCall] = useState({});
  const [currentCallId, setCurrentCallId] = useState('');
  const [currentCallNumber, setCurrentCallNumber] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [mobileDate, setMobileDate] = useState(false);
  const [exportClicked, setExportClicked] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportSuccess, setExportSuccess] = useState(false);
  const [exportError, setExportError] = useState(false);
  const [spamChecked, setSpamChecked] = useState(false);
  const [firstCallChecked, setFirstCallChecked] = useState(false);
  const csvLinkRef = useRef(null);
  const [filters, setFilters] = useState({fromDate: null, toDate: null, currDuration: null, currSource: null});

  const handleOrderByClick = (value) => {
    if(value === orderBy) {
      setOrderBy(`-${value}`);
      return;
    }

    setOrderBy(value);
  };

  const getSources = () => {
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/sources`
      )
      .then((res) => {
        setSources(res.data?.message);
      });
  };

  const updateRows = (page, perPage, sort) => {
    setIsInternalFetching(true);
    
    let sourceExpression = '';
    if(filters.currSource !== null)
      sourceExpression = `&source=${filters.currSource}`;
    

    let durationExpression = '';
    
    if(filters.currDuration !== null && filters.currDuration !== '')
      durationExpression = `&duration>=${filters.currDuration}`;
    
    let dateExpression = '';
    if (filters.fromDate !== null) {
      dateExpression = `&dateFrom=${
        filters.fromDate.getMonth() + 1
      }-${filters.fromDate.getDate()}-${filters.fromDate.getFullYear()}${
        filters.toDate !== null
          ? `&dateTo=${filters.toDate.getMonth() + 1}-${filters.toDate.getDate()}-${filters.toDate.getFullYear()}`
          : ''
      }`;
    }

    let spamFiltering = '';
    if(spamChecked){
      spamFiltering= `&is_spam=true`;
    }

    let firstCallFiltering = '';
    if(firstCallChecked === true){
      firstCallFiltering= `&is_returning_number=false`;
    }
    
    if (document.getElementById('tableBody')) {
      setTableBodyHeight(
        document.getElementById('tableBody').clientHeight > 300
          ? document.getElementById('tableBody').clientHeight
          : 300
      );
    }
    
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/${page}/${perPage}?ordering=${sort}${durationExpression}${sourceExpression}${dateExpression}${spamFiltering}${firstCallFiltering}`
      )
      .then((res) => {
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            isFetching: false,
            totalCalls: res.data.total_count,
            calls: res.data.message,
          },
        });
        setIsInternalFetching(false);
      });
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/${page}/${perPage}?status=-no answer,-failed&ordering=${sort}${durationExpression}${sourceExpression}${dateExpression}${spamFiltering}${firstCallFiltering}`
      )
      .then((res) => {
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            isFetching: false,
            totalAnsweredCalls: res.data.total_count,
            answeredCalls: res.data.message,
          },
        });
        setIsInternalFetching(false);
      });
  };

  useEffect(() => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        isFetching: true,
      },
    });
    updateRows(1, state.leads.perPage, orderBy);
  }, [1, state.leads.perPage, filters, orderBy, spamChecked, firstCallChecked]);

  const handleFilterChanged = () => {
    setFilters({fromDate, toDate, currDuration, currSource: currSource.length>0? encodeURIComponent(currSource.join(';')): null });
  }

  useEffect(() => {
    if(state.leads.callsToExport.length>0 && exportClicked){
        setExportClicked(false); 
        csvLinkRef.current.link.click();
      }
  }, [state.leads.callsToExport]);

  useEffect(() => {
    axios
      .get(`${REACT_APP_FLASK_API_URL}/websites/${state.websiteSwitch.currentWebsite}/features`)
      .then((res) => {
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            transcriptEnabled: res.data?.data?.calls_transcriptions_enabled || false,
          },
        });
      });
    getSources();
  }, []);

  const handleChangePage = (event, newPage) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentPage: newPage,
      },
    });
    updateRows(newPage + 1, state.leads.perPage, orderBy);
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        perPage: parseInt(event.target.value, 10),
        currentPage: 0,
      },
    });
    updateRows(1, parseInt(event.target.value, 10), orderBy);
  };

  if (state.leads.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }
  const handleConvertCall = () => {
    const leadBody = {
      email,
      fullName,
      message,
      phone: currentCallNumber,
      website: state.websiteSwitch.currentWebsite,
    };
    axios
      .post(
        `${REACT_APP_FLASK_API_URL}/v1/calls/convert-to-lead/${state.websiteSwitch.currentWebsite}/${currentCallId}`,
        leadBody
      )
      .then((res) => {
        if (res.data.success) {
          setOpenDialog(false);
          setConfirmationStep(false);
          updateRows(state.leads.currentPage, state.leads.perPage, orderBy);
          setEmail('');
          setFullName('');
          setMessage('');
          setCurrentCallNumber('');
          setCurrentCall({});
          setCurrentCallId('');
					confetti({
						particleCount: 200,
						angle: 40,
						spread: 100,
						origin: { x: 0 },
						zIndex: 1200,
						colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
					});
					confetti({
						particleCount: 200,
						angle: 140,
						spread: 100,
						origin: { x: 1 },
						zIndex: 1200,
						colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
					});
        }
      });
  };

  const handleDeleteDate = () => {
    setFromDate(null);
    setToDate(null);
    setFilters({...filters, fromDate: null, toDate: null});
  };

  const handleDeleteDuration = () => {
    setCurrDuration(null);
    setFilters({...filters, currDuration: null});
  };

  const handleDeleteSource = () => {
    setCurrSource([]);
    setFilters({...filters, currSource: null});
  }

  const handleClearFilters = () => {
    setFromDate(null);
    setToDate(null);
    setCurrDuration(null);
    setCurrSource([]);
    setFilters({fromDate: null, toDate: null, currDuration: null, currSource: null});
  }

  const handleOpenDate = () => {
    setMobileDate(true);
  };

  const handleFromDateChange = (date) => {
    if (date) {
      setFromDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
    }
  };
  const handleFromDateChangeMobile = (date) => {
    if (date) {
      setFilters({fromDate: new Date(date.getFullYear(), date.getMonth(), date.getDate()), toDate: filters.toDate, currDuration: null, currSource: null});
      setFromDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
    }
  };
  const handleToDateChange = (date) => {
    if (date) {
      setToDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
    }
  };
  const handleToDateChangeMobile = (date) => {
    if (date) {
      setFilters({fromDate: filters.fromDate, toDate: new Date(date.getFullYear(), date.getMonth(), date.getDate()), currDuration: null, currSource: null});
      setToDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
    }
  };

  const handleCallAudioClick = (audio) => {
    if(audio.indexOf('callrail') !== -1)  {
      window.open(audio, '_blank').focus();
    } else {
      setOpenCallDialog(true);
      setAudioUrl(audio);
    }
  }

  const handleSrcChange = (event) => {
    const {
      target: { value },
    } = event;
    setCurrSource(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const submitSpam = () => {
    const data = {
      is_spam: !currentCall.is_spam,
    };
    axios.patch(`${REACT_APP_FLASK_API_URL}/v1/calls/${currentCallId}`, data).then(() => {
      setOpenSpamDialog(false);
      confetti({
        particleCount: 200,
        angle: 40,
        spread: 100,
        origin: { x: 0 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      confetti({
        particleCount: 200,
        angle: 140,
        spread: 100,
        origin: { x: 1 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      updateRows(1, state.leads.perPage, orderBy);
    });
  };

  const submitDelete = () => {
    const data = {
      is_spam: !currentCall.is_spam,
    };
    axios.detele(`${REACT_APP_FLASK_API_URL}/v1/calls/${currentCallId}`, data).then(() => {
      setOpenDeleteDialog(false);
      confetti({
        particleCount: 200,
        angle: 40,
        spread: 100,
        origin: { x: 0 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      confetti({
        particleCount: 200,
        angle: 140,
        spread: 100,
        origin: { x: 1 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      updateRows(1, state.leads.perPage, orderBy);
    });
  };

  const addZero = (i) => {
    if (i < 10) {
      return `0${i.toString()}`;
    }
    return i;
  };

  const fetchDataAndDwnloadCSV = async () => {
    let sourceExpression = '';
    if(filters.currSource !== null)
      sourceExpression = `&source=${filters.currSource}`;

    let durationExpression = '';
    
    if(filters.currDuration !== null && filters.currDuration !== '')
      durationExpression = `&duration>=${filters.currDuration}`;

    let dateExpression = '';
    if (filters.fromDate !== null) {
      dateExpression = `&dateFrom=${
        filters.fromDate.getMonth() + 1
      }-${filters.fromDate.getDate()}-${filters.fromDate.getFullYear()}${
        filters.toDate !== null
          ? `&dateTo=${filters.toDate.getMonth() + 1}-${filters.toDate.getDate()}-${filters.toDate.getFullYear()}`
          : ''
      }`;
    }

    setExportLoading(true);
    axios
    .get(`${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/1/10000?ordering=${orderBy}${durationExpression}${sourceExpression}${dateExpression}`)
    .then((res) => {
      setExportClicked(true);
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          callsToExport: res.data.message,
        },
      });
      setExportSuccess(true);
      setExportLoading(false);
    }).catch(() => {
      setExportError(true);
      setExportLoading(false);
    });
  };

  const handleExportAlertClosed = () => {
    setExportSuccess(false);
    setExportError(false);
  }

  const audio = state.leads.answeredCalls.filter((item) => (
    item.audio !== null
  ));
  
  if (isPhone) {
    return (
      <>
        <MobileTitle title="Opportunities" />
				<div className={classes.flex__container} id="mobileHeader" style={{ marginBottom: '20px'}}>
					<TextField
            fullWidth
            className={classes.select}
            id="mobileSelect"
            defaultValue="Calls"
            value="calls"
            variant="outlined"
            select
            SelectProps={{
              IconComponent: KeyboardArrowDownIcon,
            }}
          >
            <MenuItem key={1} value="form" onClick={() => handleSourceChange('form')}>
              Form
            </MenuItem>
            <MenuItem key={2} value="calls" onClick={() => handleSourceChange('calls')}>
              Calls
            </MenuItem>
          </TextField>
          <p className={classes.fullViewIcons}>
            <InsertInvitationRoundedIcon onClick={handleOpenDate} />
          </p>
          <Dialog
            open={mobileDate}
            className={classes.datePopup}
            onClose={() => {
              setMobileDate(false);
            }}
          >
            <DialogTitle id="form-dialog-title">
              Please select the dates to filter the pages.
            </DialogTitle>
            <div className={classes.dateInputFlex}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="From"
                  value={fromDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleFromDateChangeMobile}
                  aria-label="from date picker"
                />
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="To"
                  value={toDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleToDateChangeMobile}
                />
              </MuiPickersUtilsProvider>
            </div>
          </Dialog>
				</div>
        {state.leads.answeredCalls && !isInternalFetching ? (
          <div>
            {state.leads.answeredCalls.map((row, rowNumber) => (
              <MobileCallsCard row={row} rowNumber={rowNumber} />
            ))}
          </div>
        ) : (
          <>{!isInternalFetching && <div style={{ margin: '5% 0 0 5%' }}>No results</div>}</>
        )}
        {isInternalFetching && (
           <div className={classes.root}>
            <CircularProgress />
          </div>
        )}
        {!state.leads.isSearching && (
          <StyledTablePagination
            rowsPerPageOptions={[15, 50]}
            component="div"
            count={state.leads.totalAnsweredCalls}
            rowsPerPage={state.leads.perPage}
            page={state.leads.currentPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Rows:"
          />
        )}
      </>
    );
  }
  return (
    <div>
      <div>
				<div className={classes.card__header_alone} style={{ width: '100%', justifyContent: 'flex-start' }}>
					<div className={classes.heading}>Opportunities</div>
					<Chip
						className={classes.chipMargin}
						label="Form"
						clickable
						onClick={() => handleSourceChange('form')}
					/>
					<StyledActiveChip
						className={classes.chipMargin}
						label="Calls"
						clickable
						onClick={() => handleSourceChange('calls')}
					/>
          {filters.fromDate && !filters.toDate && (
            <StyledActiveChip
              label={`From ${filters.fromDate.toLocaleString('en-US', {
                month: 'long',
              })} ${filters.fromDate.getFullYear()}`}
              className={classes.chipMargin}
              onDelete={handleDeleteDate}
              deleteIcon={<ClearIcon style={{ color: 'white' }} />}
            />
          )}
          {!filters.fromDate && filters.toDate && (
            <StyledActiveChip
              label={`From ${filters.toDate.toLocaleString('en-US', {
                month: 'long',
              })} ${filters.toDate.getFullYear()}`}
              className={classes.chipMargin}
              onDelete={handleDeleteDate}
              deleteIcon={<ClearIcon style={{ color: 'white' }} />}
            />
          )}
          {filters.fromDate && filters.toDate && (
            <StyledActiveChip
              label={`${filters.fromDate.toLocaleString('en-US', {
                month: 'long',
              })} ${fromDate.getFullYear()} - ${filters.toDate.toLocaleString('en-US', {
                month: 'long',
              })} ${filters.toDate.getFullYear()}`}
              className={classes.chipMargin}
              onDelete={handleDeleteDate}
              deleteIcon={<ClearIcon style={{ color: 'white' }} />}
            />
          )}
          {filters.currDuration && (
            <StyledActiveChip
              label={`Longer than ${filters.currDuration} seconds`}
              className={classes.chipMargin}
              onDelete={handleDeleteDuration}
              deleteIcon={<ClearIcon style={{ color: 'white' }} />}
            />
          )}
          {filters.currSource && (
            <StyledActiveChip
              label={`From ${decodeURIComponent(filters.currSource)}`}
              className={classes.chipMargin}
              onDelete={handleDeleteSource}
              deleteIcon={<ClearIcon style={{ color: 'white' }} />}
            />
          )}
            <>
              <Box style={{ marginTop: '5px', marginLeft: 'auto'}}>
                <Checkbox
                  checked={firstCallChecked}
                  color="primary"
                  onChange={() => {
                    setFirstCallChecked(!firstCallChecked)
                  }}
                  inputProps={{ 'aria-label': 'selectAll' }}
                  style={{ paddingTop: '7px', marginTop: '0px' }}
                />
                First Call
              </Box>
              {REACT_APP_HIDE_SPAM === "false" && <Box style={{ marginTop: '5px', marginLeft: '5px'}}>
                <Checkbox
                  checked={spamChecked}
                  color="primary"
                  onChange={() => setSpamChecked(!spamChecked)}
                  inputProps={{ 'aria-label': 'selectAll' }}
                  style={{ paddingTop: '7px', marginTop: '0px' }}
                />
                Show Only Spam
              </Box>}
              <div
                aria-hidden="true"
                aria-label="exportButton"
                onClick={() => fetchDataAndDwnloadCSV()}
                style={{
                  color: '#00B5E2',
                  fontSize: '1.3rem',
                  marginLeft: '20px', 
                  marginRight: '10px',
                }}>
                <u>Export to csv</u>
                {exportLoading && <CircularProgress size={20} style={{marginLeft: 5}} />}
              </div>
              <CSVLink
                data={state.leads.callsToExport}
                filename={`ctm_${state.websiteSwitch.currentWebsite}.csv`}
                ref={csvLinkRef}
                style={{
                  display: 'none'
                }}
              >
                Export to CSV
              </CSVLink>
            </>
            <Snackbar
              open={exportSuccess || exportError}
              autoHideDuration={6000}
              onClose={handleExportAlertClosed}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              key="bottom left"
            >
              {exportSuccess ? (
                <Alert onClose={handleExportAlertClosed} severity="success">
                  Data fetched successfully!
                </Alert>
              ) : (
                <Alert onClose={handleExportAlertClosed} severity="error">
                  Error parsing data!
                </Alert>
              )}
            </Snackbar>
				</div>
        <div className={classes.card__header}>
          <div style={{ width: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column' }} className={classes.searchInputFlex}>
            <Box display='flex' alignItems='center' style={{ marginLeft: 15, marginRight: 10, marginTop: 0, marginBottom: 15}} >
              <Box mr={1}>Service Provider:</Box>
              <Box>{
                (() => {
                  if (audio.length > 0) {
                    if (audio[0].audio === null) return <Chip style={{ width: "100%"}} label="-" color="warning" />;
                    if (audio[0].audio.indexOf('callrail') !== -1) return <Chip style={{ width: "100%"}} label="Call Rail" color="primary" />;
                    if (audio[0].audio.indexOf('calltrackingmetrics') !== -1) return <Chip style={{ width: "100%"}} label="CTM" color="primary" />;
                    return <Chip style={{ width: "100%"}} label="-" color="warning" />;
                  };
                  return <Chip style={{ width: "100%"}} label="-" color="warning" />;
                })()
              }</Box>
            </Box>
            <Box display='flex' alignItems='center'>
              <Box style={{ marginLeft: 15, marginRight: 10}}>Filter By:</Box>
            </Box>
            <Box display='flex' my={2}>
              <Box display='flex' alignItems='center'>
                <Box style={{ marginLeft: 15, marginRight: 10}}>Date</Box>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    variant="inline"
                    inputVariant="outlined"
                    label="From"
                    value={fromDate}
                    style={{ paddingRight: 20 }}
                    onChange={handleFromDateChange}
                    aria-label="from date picker"
                  />
                  <DatePicker
                    variant="inline"
                    inputVariant="outlined"
                    label="To"
                    value={toDate}
                    style={{ paddingRight: 20 }}
                    onChange={handleToDateChange}
                  />
                </MuiPickersUtilsProvider>
              </Box>
              <Box display='flex' alignItems='center'>
                <Box style={{ marginLeft: 15, marginRight: 10}}>Duration</Box>
                <TextField
                  id="duration-field"
                  type="number"
                  placeholder="Start Typing"
                  className={classes.searchInput}
                  value={currDuration}
                  onChange={(e) => {
                    setCurrDuration(e.target.value);
                  }}
                  variant="standard"
                />
              </Box>
              <Box display='flex' alignItems='center'>
                <Box style={{ marginLeft: 15, marginRight: 10}}>Source</Box>
                {sources?.length > 0 && <Select
                  value={currSource}
                  multiple
                  onChange={handleSrcChange}
                  style={{width: '150px'}}
                > 
                  {sources.map((el) => (
                    <MenuItem
                      key={el}
                      value={el}
                    >
                      {el}
                    </MenuItem>
                  ))}
                </Select>}
              </Box>
              
            <Box display='flex'>
              <SubmitButton
                variant="contained"
                onClick={handleFilterChanged}
              >
                Filter
              </SubmitButton>
              {Object.values(filters).filter((f) => f !== null).length > 0 && (
              <RedButton
                variant="contained"
                onClick={handleClearFilters}
                style={{
                  margin: "0 0 0 15px",
                  borderRadius: 5,
                }}
              >
                Clear
              </RedButton>)}
            </Box>
            </Box>
          </div>
        </div>
				{state.leads.totalAnsweredCalls ? (
					<>
            {Object.values(filters).reduce((result, element) => result || element !== null, false) && <Box pb={2}>{state.leads.totalAnsweredCalls} results</Box>}
						<Table>
							<TableHead className={classes.opportunities__table}>
								<TableRow>
                  <StyledTableHeadCell1 style={{ position: 'relative' }}>
                    <Box display='flex' flex={1} justifyContent='space-between'>
                      No.
                    </Box>
                  </StyledTableHeadCell1>
                  <StyledTableHeadCell1>
                    <Box style={{cursor: 'pointer'}}
                        >
                      &nbsp;
                    </Box>
									</StyledTableHeadCell1>
									<StyledTableHeadCell1>
                    <Box onClick={() => handleOrderByClick('called_at_new')} style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                        >
                      Date{' '}
                      {(orderBy === 'called_at_new' || orderBy === '-called_at_new') && <SortIcon
                        className={`${classes.sortIcon} ${orderBy === 'called_at_new' ? 'asc' : ''}`}
                      />}
                    </Box>
									</StyledTableHeadCell1>
									<StyledTableHeadCell>
                    <Box>
                      Time 
                    </Box>
                  </StyledTableHeadCell>
									<StyledTableHeadCell align="left">
                    <Box onClick={() => handleOrderByClick('caller_number_complete')} style={{cursor: 'pointer'}}>
                      Phone
                      {(orderBy === 'caller_number_complete' || orderBy === '-caller_number_complete') && <SortIcon
                        className={`${classes.sortIcon} ${orderBy === 'caller_number_complete' ? 'asc' : ''}`}
                        onClick={() => handleOrderByClick('phone')}
                        style={{ position: 'relative', top: '5px'}}
                      />}
                    </Box>
                  </StyledTableHeadCell>
                  <StyledTableHeadCell align="center">
                    <Box onClick={() => handleOrderByClick('status')} style={{cursor: 'pointer'}}>
                      Status
                      {(orderBy === 'status' || orderBy === '-status') && <SortIcon
                        className={`${classes.sortIcon} ${orderBy === 'status' ? 'asc' : ''}`}
                        onClick={() => handleOrderByClick('status')}
                        style={{ position: 'relative', top: '5px'}}
                      />}
                    </Box>
                  </StyledTableHeadCell>
                  <StyledTableHeadCell align="center">
                    <Box onClick={() => handleOrderByClick('is_returning_number')} style={{cursor: 'pointer'}}>
                      First Call
                      {(orderBy === 'is_returning_number' || orderBy === '-is_returning_number') && <SortIcon
                        className={`${classes.sortIcon} ${orderBy === 'is_returning_number' ? 'asc' : ''}`}
                        onClick={() => handleOrderByClick('is_returning_number')}
                        style={{ position: 'relative', top: '5px'}}
                      />}
                    </Box>
                  </StyledTableHeadCell>
									<StyledTableHeadCell align="center">
                    <Box onClick={() => handleOrderByClick('duration')} style={{cursor: 'pointer'}}>
                      Duration
                      {(orderBy === 'duration' || orderBy === '-duration') && <SortIcon
                        className={`${classes.sortIcon} ${orderBy === 'duration' ? 'asc' : ''}`}
                        style={{ position: 'relative', top: '5px'}}
                      />}
                    </Box>
                  </StyledTableHeadCell>
									<StyledTableHeadCell align="center">
                    Recording
                  </StyledTableHeadCell>
                  {state.leads.transcriptEnabled && <StyledTableHeadCell align="center">
                    Transcript
                  </StyledTableHeadCell>}
									<StyledTableHeadCell align="left">
                    <Box onClick={() => handleOrderByClick('source')} style={{cursor: 'pointer'}}>
                      Source
                      {(orderBy === 'source' || orderBy === '-source') && <SortIcon
                        className={`${classes.sortIcon} ${orderBy === 'source' ? 'asc' : ''}`}
                        style={{ position: 'relative', top: '5px'}}
                      />}
                    </Box>
                  </StyledTableHeadCell>
									<StyledTableHeadCell2 align="center">Action</StyledTableHeadCell2>
								</TableRow>
							</TableHead>
							{!isInternalFetching && (
								<TableBody id="tableBody">
									{state.leads.answeredCalls.map((row, rowNumber) => (
                    <CallsTableRow row={row} rowNumber={rowNumber} handleCallAudioClick={handleCallAudioClick} addZero={addZero} currentCallId={currentCallId} setCurrentCall={setCurrentCall} setCurrentCallNumber={setCurrentCallNumber} setCurrentDate={setCurrentDate} setCurrentCallId={setCurrentCallId} setOpenDialog={setOpenDialog} setOpenSpamDialog={setOpenSpamDialog} setOpenDeleteDialog={setOpenDeleteDialog} />
									))}
								</TableBody>
							)}
						</Table>
					</>
				) : (
					<>
						{!isInternalFetching && (
							<div className={classes.noContentBlock}>
								<span>No Results</span>
							</div>
						)}
					</>
				)}
			</div>
			{isInternalFetching && (
				<div className={classes.loading} style={{ height: tableBodyHeight }}>
					<CircularProgress />
				</div>
			)}
			<Divider />
			<div className={classes.card__wrapper}>
				<div className={classes.cardActionButton} aria-hidden="true">
					<StyledTablePagination
						rowsPerPageOptions={[15, 50]}
						component="div"
						count={state.leads.totalAnsweredCalls}
						rowsPerPage={state.leads.perPage}
						page={state.leads.currentPage}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</div>
			</div>
      <Dialog
        open={openCallDialog}
        onClose={() => {
          setOpenCallDialog(false);
          setAudioUrl(null);
          setCurrentCallNumber('');
          setCurrentCallId('');
        }}
        className={classes.callDialog}
      >
        <DialogTitle style={{ color: 'white'}}>
          <Box>Phone: {currentCallNumber}</Box>
          <Box>Date: {`${new Date(currentDate).toLocaleString('en-US', { timeZone: 'UTC', year: 'numeric', month: 'short', day: '2-digit' })}`}</Box>
        </DialogTitle>
        <DialogContent>
          <Box>
            <Box className={classes.iframeWrapper} mb={10}>
              <iframe title='audio' style={{ display: 'block', background: 'none', border: 'none'}} width='600px' height='150px' src={audioUrl} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box >
            <Button
              onClick={() => {
                setOpenCallDialog(false);
                setAudioUrl(null);
                setCurrentCallNumber('');
                setCurrentCallId('');
              }}
              style={{ color: '#fff' }}
            >
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setFullName('');
          setMessage('');
          setCurrentCallNumber('');
          setCurrentCallId('');
          setConfirmationStep(false);
        }}
      >
        <DialogTitle>Convert {currentCallNumber} Call to Lead</DialogTitle>
        <DialogContent>
        {!confirmationStep && <Box textAlign='left'>Are you sure you want to add this opportunity to Leads?</Box>}
        {confirmationStep && <Box fontWeight='bold' py={2} textAlign='left'>Please review lead data before continue this action cannot be reverted</Box>}
          <Box display={confirmationStep ? 'none' : 'block'}>
            <TextField
              margin="dense"
              id="full name"
              label="Contact's Full Name *"
              fullWidth
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
              }}
            />
            <TextField
              margin="dense"
              id="full name"
              label="Contact's Email *"
              fullWidth
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <DefaultInput
              style={{ marginTop: 10, width: '100%' }}
              rows={5}
              multiline
              label="Message"
              value={message}
              data-testid="details_test_id"
              type="text"
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            />
          </Box>
          <Box display={confirmationStep ? 'block' : 'none'}>
            <Box>
              <Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>Email: </Box>
              <span>
                {email}
              </span>
            </Box>
            <Box>
              <Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>Full Name: </Box>
              <span>
                {fullName}
              </span>
            </Box>
            <Box>
              <Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>Message: </Box>
              <span>
                {message}
              </span>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
        <Box display={confirmationStep ? 'none' : 'block'}>
            <Button
              onClick={() => {
                setOpenDialog(false);
                setFullName('');
                setMessage('');
                setCurrentCallNumber('');
                setCurrentCallId('');
                setConfirmationStep(false);
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={() => {
                setConfirmationStep(true)
              }} >
              Review
            </GreenButton>
          </Box>
          <Box display={confirmationStep ? 'block' : 'none'}>
            <Button
              onClick={() => {
                setConfirmationStep(false);
              }}
              style={{ color: '#58595B' }}
            >
              Back
            </Button>
            <GreenButton aria-label="submit convert" onClick={handleConvertCall} style={{ fontSize: '1rem' }}>
              Submit
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSpamDialog}
        onClose={() => {
          setOpenSpamDialog(false);
          setCurrentCall({});
          setCurrentCallNumber('');
          setCurrentCallId('');
        }}
        className={classes.addLeadPopup}
      >
        <DialogContent>
          <Box style={{ textAlign: 'center'}}>
            <Box margin="auto" textAlign="center"><img style={{ margin: 'auto'}} alt='action' src={currentCall.is_spam ? CheckIcon : WarningIcon} height="60" /></Box>
            <Box mt={2} mb={2} textAlign='center'>{currentCall.is_spam ? <Box>You are about to <Box style={{ color: 'green', display: 'inline-block'}}>unmark</Box> this Opportunity as Spam</Box> : <Box>You are about to <Box style={{ color: 'red', display: 'inline-block'}}>mark</Box> this Opportunity as Spam</Box>}</Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='block'>
            <Button
              onClick={() => {
                setOpenSpamDialog(false);
                setCurrentCall({});
                setCurrentCallNumber('');
                setCurrentCallId('');
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitSpam} style={{ fontSize: '1rem' }}>
              Confirm
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteDialog}
        onClose={() => {
          setOpenDeleteDialog(false);
          setCurrentCall({});
          setCurrentCallNumber('');
          setCurrentCallId('');
        }}
        className={classes.addLeadPopup}
      >
        <DialogContent>
          <Box style={{ textAlign: 'center'}}>
            <Box margin="auto" textAlign="center"><img style={{ margin: 'auto'}} alt='action' src={WarningIcon} height="60" /></Box>
            <Box mt={2} mb={2} textAlign='center'><Box>You are about to <Box style={{ color: 'red', display: 'inline-block'}}>delete</Box> this Opportunity</Box></Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='block'>
            <Button
              onClick={() => {
                setOpenDeleteDialog(false);
                setCurrentCall({});
                setCurrentCallNumber('');
                setCurrentCallId('');
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitDelete} style={{ fontSize: '1rem' }}>
              Confirm
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};

CallsOpportunitiesTable.propTypes = {
  handleSourceChange: PropTypes.func,
};

CallsOpportunitiesTable.defaultProps = {
  handleSourceChange: () => {},
};

export default CallsOpportunitiesTable;
